module.exports = __webpack_public_path__ + "static/media/10s.fba8958d.png";